<template>
  <el-row class="mr-b30 mr-t10 auto-bg">
    <el-col :span="6">
      <div class="auto-list">
        <div class="light"></div>
        <span class="auto-list-tit">전체 대상 수</span>
        <span class="list-unit">현재</span>
        <div class="mr-t15" style="text-align: right;">
          <span class="list-value-tit">장비</span>
          <span class="list-value">{{ nodeCount }}</span>
        </div>
      </div>
    </el-col>
    <el-col :span="6">
      <div class="auto-list">
        <div class="light"></div>
        <span class="auto-list-tit">전체 템플릿 수</span>
        <span class="list-unit">현재</span>
        <div class="mr-t15" style="text-align: right;">
          <span class="list-value-tit">템플릿</span>
          <span class="list-value">{{ trgCount }}</span>
        </div>
      </div>
    </el-col>
    <el-col :span="6">
      <div class="auto-list c-pointer" @click="changeActiveTab('S')">
        <div class="light"></div>
        <span class="auto-list-tit">작업 성공률</span>
        <div style="height: 23px"></div>
        <div class="mr-t15" style="text-align: right;">
          <span class="list-value-tit">성공률</span>
          <span class="list-value">{{ successRate }}</span>
          <span style="font-size: 16px;">%</span>
        </div>
      </div>
    </el-col>
    <el-col :span="6">
      <div class="auto-list c-pointer" @click="changeActiveTab('F')">
        <div class="light"></div>
        <span class="auto-list-tit">템플릿 실패/부분성공</span>
        <div style="height: 23px"></div>
        <div class="mr-t15" style="text-align: right;">
          <span class="list-value-tit">실패<span style="margin: 0 3px;">/</span>부분성공</span>
          <span class="list-value">{{ failCount }}<span style="margin: 0 4px;">/</span>{{ partialSuccessCount }}</span>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { isNil, isEqual } from 'lodash';
import { mapGetters } from 'vuex';
import amsSummaryApi from '@/api/ams/summary';

export default {
  name: 'WTriggerNodeCountView',
  props: {
    tabActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      nodeCount: 0,
      trgCount: 0,
      successRate: 0,
      failCount: 0,
      partialSuccessCount: 0,
    };
  },
  computed: {
    ...mapGetters(['analysisDateParams']),
  },
  watch: {
    tabActive: {
      handler(flag) {
        if (flag) {
          this.loadData();
        }
      },
      immediate: true,
    },
    analysisDateParams() {
      this.loadData();
    },
  },
  methods: {
    loadData() {
      if (!this.tabActive) return;
      amsSummaryApi.getTriggerNodeCountViewData({
        startDatetime: this.analysisDateParams.startDatetime,
        endDatetime: this.analysisDateParams.endDatetime,
      }).then((response) => {
        if (response.data.success) {
          const dataMap = response.data.data;
          const countMap = dataMap.resultFlagCount.reduce((acc, value) => {
            acc[value.resultFlag] = value.resultFlagCount;
            return acc;
          }, {});

          this.nodeCount = dataMap.nodeCount;
          this.trgCount = dataMap.trgCount;
          this.successRate = isNil(countMap.S) ? 0 : Math.ceil((countMap.S / countMap.TOTAL) * (100 ** 2)) / 100;
          this.failCount = isNil(countMap.F) ? 0 : countMap.F;
          this.partialSuccessCount = isNil(countMap.PS) ? 0 : countMap.PS;
        }
      });
    },
    /**
     * 특정 카운트 뷰 선택시 수행결과 화면으로 이동
     * @author jeee12
     * @return {[type]} [description]
     */
    changeActiveTab(type) {
      if (isEqual(type, 'S')) {
        const item = {
          tagType: 'info',
          type: 'resultStatus',
          selected: true,
          label: '성공',
          name: '성공',
        };
        this.$emit('change-active-tab', 'result', 'TRIGGER', [item]);
      } else {
        const items = [
          {
            tagType: 'info',
            type: 'resultStatus',
            selected: true,
            label: '부분성공',
            name: '부분성공',
          },
          {
            tagType: 'info',
            type: 'resultStatus',
            selected: true,
            label: '실패',
            name: '실패',
          },
        ];
        this.$emit('change-active-tab', 'result', 'TRIGGER', items);
      }
    },
  },
};
</script>

<style lang="scss">
$url : '../../../../../../assets/img/';

.auto-wrap .auto-bg {
  height: 160px;
}

.auto-wrap .auto-bg .auto-list {
  background: #2c518a;
  margin-right: 20px;
  height: 100%;
  border-radius: 5px;
  padding: 20px 25px 25px 25px;
  color: #fff;
  letter-spacing: -0.04rem;
  position: relative;
}

.auto-list-tit {
  font-size: 15px;
  line-height: 1.5;
  display: block;
}

.list-unit {
  background: #bccfeb;
  border-radius: 20px;
  font-size: 12px;
  color: #2c518a;
  font-weight: 600;
  padding: 5px 8px 4px 7px;
  line-height: 12px;
  display: inline-block;
  margin-top: 3px;
}

.list-value-tit {
  color:#fff;
  display: block;
  font-size: 16px;
  line-height: 16px;
  color: #b0c2f1;
  font-weight: 600;
  letter-spacing: -0.5px;
}

.list-value {
  font-size: 30px;
  line-height: 1.4;
  font-weight: 500;
  letter-spacing: 0;
}

.light {
  background: url($url + 'light.png') no-repeat;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 2;
  display: block;
  width: 221px;
  right: 0;
  opacity: 0.8;
}
</style>



// WEBPACK FOOTER //
// src/views/work/popup/components/ExecutionSummary/components/TriggerNodeCountView.vue